import axios from "axios";

export default class SalonPromoController {
    static async show(clubId: string | number, salonId: string | number) {
        const result = await axios.get<Resources.ClubPromo>(`/api/club/customer/clubs/${clubId}/salons/${salonId}/promo`)
        return result.data
    }
}